var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.900316 0.956435C1.23593 0.620824 1.76264 0.592637 2.13013 0.872271L2.22619 0.956125L8.63553 7.36335L15.0464 0.952457C15.4125 0.586352 16.0061 0.586352 16.3723 0.952457C16.7079 1.28807 16.7358 1.81486 16.4562 2.18229L16.3723 2.27828L9.96136 8.68918L16.3705 15.0948C16.7367 15.4608 16.7369 16.0545 16.3708 16.4206C16.0352 16.7562 15.5085 16.7844 15.141 16.5047L15.0449 16.4209L8.63553 10.015L2.22826 16.4223C1.86214 16.7884 1.26854 16.7884 0.902437 16.4223C0.566827 16.0867 0.538852 15.5599 0.818495 15.1924L0.902437 15.0964L7.30971 8.68918L0.900625 2.28222C0.534423 1.91619 0.534211 1.32254 0.900316 0.956435Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.8869f1b31eb7606793e4e0682d064794.svg";
export { ForwardRef as ReactComponent };